import React, { useEffect, useRef, useState } from 'react';
import './inputNumber.style.scss';
import { __NumInputProps, __InputNumberRef } from './inputNumber.interface';
import { Language, ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { prsNum2Eng } from 'scripts/string';
import { extractTitle } from 'scripts/string';
export interface SLPNumberInputRef extends __InputNumberRef {}

const SLPInputNumber: React.ForwardRefRenderFunction<
    __InputNumberRef,
    ConnectedProps<typeof connector> & __NumInputProps
> = (props: ConnectedProps<typeof connector> & __NumInputProps, ref) => {
    const lang = props.lang.utilities;
    const inputRef = useRef<HTMLInputElement>(null);
    const [error, setError] = useState<string>();
    // const [disabled, setDisabled] = useState<boolean>(false);
    const [active, setActive] = useState<boolean>(false);
    const immediateValue = useRef(props.defaultValue ? props.defaultValue : null);
    const [value, setValue] = useState(immediateValue.current ? immediateValue.current.toString() : null);
    const labelRef = useRef<HTMLLabelElement>(null);
    React.useImperativeHandle(ref, () => ({
        getValue: () => (inputRef.current?.value.length ? Number(inputRef.current?.value) : null),
        getValidation: () => Validation(),
        // setValue,
        setError: (text: string) => {
            setError(text);
        },
        setUnError: () => setError(undefined),
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    function onFocusHandler() {
        setActive(true);
    }

    function onblurHandler() {
        setActive(false);
    }

    function onClickHandler() {
        inputRef.current?.focus();
    }

    function Validation() {
        let validate = true;
        if (immediateValue.current)
            if (
                (props.required && !immediateValue.current) ||
                (props.minEqual && immediateValue.current < props.minEqual) ||
                (props.maxEqual && immediateValue.current > props.maxEqual) ||
                (props.min && immediateValue.current <= props.min) ||
                (props.max && immediateValue.current >= props.max)
            )
                validate = false;
        return validate;
    }

    function onChangeHandler(e: React.ChangeEvent<HTMLInputElement>) {
        setError(undefined);
        immediateValue.current =
            e.target.value !== '-' && e.target.value.length ? Number(prsNum2Eng(e.target.value)) : null;
        setValue(prsNum2Eng(e.target.value));
        console.log(immediateValue.current);
        if (props.onChange) props.onChange(immediateValue.current);
    }

    function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.charCode === 13 && props.onEnter) {
            e.preventDefault();
            e.currentTarget.blur();
            props.onEnter(immediateValue.current);
        }
        if (e.key === '-' && (e.currentTarget.selectionStart !== 0 || (value ?? '').toString().includes('-')))
            e.preventDefault();
        else if (
            e.key === '.' &&
            ((value?.charAt(0) !== '-' && e.currentTarget.selectionStart === 0) ||
                (value?.charAt(0) === '-' && e.currentTarget.selectionStart === 1) ||
                (value ?? '').toString().includes('.'))
        )
            e.preventDefault();
        else if (e.key !== '.' && e.key !== '-' && isNaN(Number(prsNum2Eng(e.key)))) e.preventDefault();
    }
    return (
        <div
            onClick={onClickHandler}
            className={`ucheck-SLP-num-input ${(value ?? '').length ? 'filled' : ''} ${active ? 'active' : ''} ${
                error ? 'error' : ''
            } ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}
        >
            <div className="input-header">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className={`input-container ${props.endIcon ? 'has-end-icon' : ''} `}>
                <input
                    ref={inputRef}
                    type="text"
                    value={value !== null ? value.toString() : ''}
                    onFocus={onFocusHandler}
                    onBlur={onblurHandler}
                    required={props.required}
                    onChange={onChangeHandler}
                    style={{ color: props.color }}
                    placeholder={props.formLang === Language.en ? lang.SLPNumberPHEn : lang.SLPNumberPH}
                    onKeyPress={onKeyPress}
                    enterKeyHint="next"
                />
                {props.endIcon && (
                    <i className="material-icons" style={{ color: props.endIcon.color }}>
                        {props.endIcon.icon}
                    </i>
                )}
            </div>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPInputNumber));
